import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, ViewChild, Injectable, signal, inject, ElementRef, ViewContainerRef, Directive, Input, input, TemplateRef, ContentChild, NgModule } from '@angular/core';
import { TourService, TourState, TourHotkeyListenerComponent, BaseTourProxyAnchor } from 'ngx-ui-tour-core';
import { first } from 'rxjs';
import * as i1 from '@angular/material/menu';
import { MatMenuTrigger, MatMenuModule, MatMenu } from '@angular/material/menu';
import { NgTemplateOutlet } from '@angular/common';
import * as i1$1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/material/card';
import { MatCardModule } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
function TourDefaultStepTemplateComponent_Conditional_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const step_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2("", ctx_r1.tourService.steps.indexOf(step_r3) + 1, " / ", ctx_r1.tourService.steps.length, "");
  }
}
function TourDefaultStepTemplateComponent_Conditional_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 8);
    i0.ɵɵlistener("click", function TourDefaultStepTemplateComponent_Conditional_16_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.tourService.next());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementStart(2, "mat-icon", 9);
    i0.ɵɵtext(3, "chevron_right");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const step_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", step_r3.nextBtnTitle, " ");
  }
}
function TourDefaultStepTemplateComponent_Conditional_17_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 10);
    i0.ɵɵlistener("click", function TourDefaultStepTemplateComponent_Conditional_17_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.tourService.end());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext();
    const step_r3 = i0.ɵɵreadContextLet(0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", step_r3.endBtnTitle, " ");
  }
}
const _c0 = a0 => ({
  step: a0
});
function TourStepTemplateComponent_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function TourStepTemplateComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tour-default-step-template", 3);
  }
  if (rf & 2) {
    const step_r1 = ctx.step;
    i0.ɵɵproperty("step", step_r1);
  }
}
let TourAnchorOpenerComponent = /*#__PURE__*/(() => {
  class TourAnchorOpenerComponent {
    static {
      this.ɵfac = function TourAnchorOpenerComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourAnchorOpenerComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourAnchorOpenerComponent,
        selectors: [["tour-anchor-opener"]],
        viewQuery: function TourAnchorOpenerComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatMenuTrigger, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.trigger = _t.first);
          }
        },
        decls: 1,
        vars: 1,
        consts: [[3, "matMenuTriggerFor", "matMenuTriggerRestoreFocus"]],
        template: function TourAnchorOpenerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "span", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("matMenuTriggerRestoreFocus", false);
          }
        },
        dependencies: [MatMenuModule, i1.MatMenuTrigger],
        styles: ["[_nghost-%COMP%]{display:none}"],
        changeDetection: 0
      });
    }
  }
  return TourAnchorOpenerComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourStepTemplateService = /*#__PURE__*/(() => {
  class TourStepTemplateService {
    static {
      this.ɵfac = function TourStepTemplateService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourStepTemplateService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TourStepTemplateService,
        factory: TourStepTemplateService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TourStepTemplateService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgxmTourService = /*#__PURE__*/(() => {
  class NgxmTourService extends TourService {
    initialize(steps, stepDefaults) {
      const userDefaults = this.getDefaults();
      stepDefaults ??= {};
      stepDefaults.showArrow ??= userDefaults?.showArrow ?? true;
      super.initialize(steps, stepDefaults);
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNgxmTourService_BaseFactory;
        return function NgxmTourService_Factory(__ngFactoryType__) {
          return (ɵNgxmTourService_BaseFactory || (ɵNgxmTourService_BaseFactory = i0.ɵɵgetInheritedFactory(NgxmTourService)))(__ngFactoryType__ || NgxmTourService);
        };
      })();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: NgxmTourService,
        factory: NgxmTourService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return NgxmTourService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourAnchorMatMenuDirective = /*#__PURE__*/(() => {
  class TourAnchorMatMenuDirective {
    constructor() {
      this.isActive = signal(false);
      this.element = inject(ElementRef);
      this.viewContainer = inject(ViewContainerRef);
      this.tourService = inject(NgxmTourService);
      this.tourStepTemplate = inject(TourStepTemplateService);
    }
    ngOnInit() {
      this.tourService.register(this.tourAnchor, this);
    }
    ngOnDestroy() {
      this.tourService.unregister(this.tourAnchor);
    }
    createOpener() {
      this.opener = this.viewContainer.createComponent(TourAnchorOpenerComponent).instance;
    }
    // noinspection JSUnusedGlobalSymbols
    showTourStep(step) {
      this.isActive.set(true);
      this.tourStepTemplate.templateComponent.step = step;
      if (!this.opener) {
        this.createOpener();
      }
      const trigger = this.opener.trigger,
        customTrigger = trigger;
      customTrigger._element = this.element;
      // Fixes tour step closing when hovering over mat-menu item, issue #123
      customTrigger._parentMaterialMenu = null;
      // Overrides position setting to support opening to the sides
      customTrigger._setPosition = (menu, positionStrategy) => this.setPosition(menu, positionStrategy, step);
      const menu = this.tourStepTemplate.templateComponent.tourStep;
      trigger.menu = menu;
      menu.xPosition = step.placement?.xPosition || 'after';
      menu.yPosition = step.placement?.yPosition || 'below';
      menu.hasBackdrop = !!step.closeOnOutsideClick;
      // Prevent tab key closing the menu. Issue #189
      menu._keyManager.tabOut.complete();
      const popoverClass = step.popoverClass ?? '',
        arrow = step.showArrow ? 'arrow' : '',
        horizontal = step.placement?.horizontal ? 'horizontal' : '';
      menu.panelClass = `tour-step ${popoverClass} ${arrow} ${horizontal}`;
      trigger.openMenu();
      if (this.menuCloseSubscription) {
        this.menuCloseSubscription.unsubscribe();
      }
      this.menuCloseSubscription = trigger.menuClosed.pipe(first()).subscribe(() => {
        if (this.tourService.getStatus() !== TourState.OFF) {
          this.tourService.end();
        }
      });
    }
    setPosition(menu, positionStrategy, step) {
      let [originX, originFallbackX] = menu.xPosition === 'before' ? ['end', 'start'] : ['start', 'end'];
      const [overlayY, overlayFallbackY] = menu.yPosition === 'above' ? ['bottom', 'top'] : ['top', 'bottom'];
      let [originY, originFallbackY] = [overlayY, overlayFallbackY];
      let [overlayX, overlayFallbackX] = [originX, originFallbackX];
      const isHorizontal = step.placement?.horizontal;
      if (isHorizontal) {
        overlayFallbackX = originX = menu.xPosition === 'before' ? 'start' : 'end';
        originFallbackX = overlayX = originX === 'end' ? 'start' : 'end';
      } else if (!menu.overlapTrigger) {
        originY = overlayY === 'top' ? 'bottom' : 'top';
        originFallbackY = overlayFallbackY === 'top' ? 'bottom' : 'top';
      }
      const offset = step.backdropConfig?.offset ?? 0,
        offsetX = isHorizontal ? offset : -offset,
        offsetY = isHorizontal ? -offset : offset;
      const original = {
        originX,
        originY,
        overlayX,
        overlayY,
        offsetX,
        offsetY
      };
      const flipX = {
        originX: originFallbackX,
        originY,
        overlayX: overlayFallbackX,
        overlayY,
        offsetX: -offsetX,
        offsetY
      };
      const flipY = {
        originX,
        originY: originFallbackY,
        overlayX,
        overlayY: overlayFallbackY,
        offsetX,
        offsetY: -offsetY
      };
      const flipXY = {
        originX: originFallbackX,
        originY: originFallbackY,
        overlayX: overlayFallbackX,
        overlayY: overlayFallbackY,
        offsetX: -offsetX,
        offsetY: -offsetY
      };
      positionStrategy.withPositions(isHorizontal ? [original, flipX] : [original, flipY, flipXY]);
    }
    // noinspection JSUnusedGlobalSymbols
    hideTourStep() {
      this.isActive.set(false);
      if (this.menuCloseSubscription) {
        this.menuCloseSubscription.unsubscribe();
      }
      this.opener.trigger.closeMenu();
    }
    static {
      this.ɵfac = function TourAnchorMatMenuDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourAnchorMatMenuDirective)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: TourAnchorMatMenuDirective,
        selectors: [["", "tourAnchor", ""]],
        hostVars: 2,
        hostBindings: function TourAnchorMatMenuDirective_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("touranchor--is-active", ctx.isActive());
          }
        },
        inputs: {
          tourAnchor: "tourAnchor"
        }
      });
    }
  }
  return TourAnchorMatMenuDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourDefaultStepTemplateComponent = /*#__PURE__*/(() => {
  class TourDefaultStepTemplateComponent {
    constructor() {
      this.step = input.required();
      this.tourService = inject(NgxmTourService);
    }
    static {
      this.ɵfac = function TourDefaultStepTemplateComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourDefaultStepTemplateComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourDefaultStepTemplateComponent,
        selectors: [["tour-default-step-template"]],
        inputs: {
          step: [1, "step"]
        },
        decls: 18,
        vars: 16,
        consts: [[3, "click"], [1, "header-group"], ["mat-icon-button", "", 1, "close", 3, "click"], [1, "mat-body", 3, "innerHTML"], ["mat-button", "", 1, "prev", 3, "click", "disabled"], [1, "progress"], ["mat-button", "", 1, "next"], ["mat-button", ""], ["mat-button", "", 1, "next", 3, "click"], ["iconPositionEnd", ""], ["mat-button", "", 3, "click"]],
        template: function TourDefaultStepTemplateComponent_Template(rf, ctx) {
          if (rf & 1) {
            const _r1 = i0.ɵɵgetCurrentView();
            i0.ɵɵdeclareLet(0);
            i0.ɵɵelementStart(1, "mat-card", 0);
            i0.ɵɵlistener("click", function TourDefaultStepTemplateComponent_Template_mat_card_click_1_listener($event) {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView($event.stopPropagation());
            });
            i0.ɵɵelementStart(2, "mat-card-header")(3, "div", 1)(4, "mat-card-title");
            i0.ɵɵtext(5);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "button", 2);
            i0.ɵɵlistener("click", function TourDefaultStepTemplateComponent_Template_button_click_6_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.tourService.end());
            });
            i0.ɵɵelementStart(7, "mat-icon");
            i0.ɵɵtext(8, "close");
            i0.ɵɵelementEnd()()()();
            i0.ɵɵelement(9, "mat-card-content", 3);
            i0.ɵɵelementStart(10, "mat-card-actions")(11, "button", 4);
            i0.ɵɵlistener("click", function TourDefaultStepTemplateComponent_Template_button_click_11_listener() {
              i0.ɵɵrestoreView(_r1);
              return i0.ɵɵresetView(ctx.tourService.prev());
            });
            i0.ɵɵelementStart(12, "mat-icon");
            i0.ɵɵtext(13, "chevron_left");
            i0.ɵɵelementEnd();
            i0.ɵɵtext(14);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(15, TourDefaultStepTemplateComponent_Conditional_15_Template, 2, 2, "div", 5)(16, TourDefaultStepTemplateComponent_Conditional_16_Template, 4, 1, "button", 6)(17, TourDefaultStepTemplateComponent_Conditional_17_Template, 2, 1, "button", 7);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const step_r6 = i0.ɵɵstoreLet(ctx.step());
            i0.ɵɵadvance();
            i0.ɵɵstyleProp("width", step_r6.stepDimensions == null ? null : step_r6.stepDimensions.width)("min-width", step_r6.stepDimensions == null ? null : step_r6.stepDimensions.minWidth)("max-width", step_r6.stepDimensions == null ? null : step_r6.stepDimensions.maxWidth);
            i0.ɵɵadvance(4);
            i0.ɵɵtextInterpolate1(" ", step_r6.title, " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("innerHTML", step_r6.content, i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance();
            i0.ɵɵclassProp("no-progress", !step_r6.showProgress);
            i0.ɵɵadvance();
            i0.ɵɵproperty("disabled", !ctx.tourService.hasPrev(step_r6));
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", step_r6.prevBtnTitle, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(step_r6.showProgress ? 15 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.tourService.hasNext(step_r6) && !step_r6.nextOnAnchorClick ? 16 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(!ctx.tourService.hasNext(step_r6) ? 17 : -1);
          }
        },
        dependencies: [MatButtonModule, i1$1.MatButton, i1$1.MatIconButton, MatCardModule, i2.MatCard, i2.MatCardActions, i2.MatCardContent, i2.MatCardHeader, i2.MatCardTitle, MatIcon],
        styles: ["html[_ngcontent-%COMP%]{--mat-icon-button-touch-target-display: none}.mat-mdc-icon-button.mat-mdc-button-base[_ngcontent-%COMP%]{--mdc-icon-button-state-layer-size: 36px;width:var(--mdc-icon-button-state-layer-size);height:var(--mdc-icon-button-state-layer-size);padding:6px}mat-card[_ngcontent-%COMP%]{box-shadow:none}mat-card-content[_ngcontent-%COMP%]{margin:8px 0}mat-card-actions[_ngcontent-%COMP%]{display:grid;grid-template-columns:1fr auto 1fr;align-items:center;gap:8px}mat-card-actions[_ngcontent-%COMP%]   .progress[_ngcontent-%COMP%]{font-size:12px;font-weight:600;color:#00000061;white-space:nowrap}mat-card-actions.no-progress[_ngcontent-%COMP%]{grid-template-columns:1fr 1fr}mat-card-actions[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{max-width:fit-content}mat-card-actions[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]:last-child{justify-self:flex-end}mat-card-actions[_ngcontent-%COMP%]   button.prev[_ngcontent-%COMP%]{padding-left:4px}mat-card-actions[_ngcontent-%COMP%]   button.next[_ngcontent-%COMP%]{padding-right:4px}mat-card-header[_ngcontent-%COMP%]   .header-group[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between;margin-top:-8px;width:100%}mat-card-header[_ngcontent-%COMP%]   .header-group[_ngcontent-%COMP%]   mat-card-title[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}mat-card-header[_ngcontent-%COMP%]   .header-group[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{margin-right:-8px}"],
        changeDetection: 0
      });
    }
  }
  return TourDefaultStepTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourStepTemplateComponent = /*#__PURE__*/(() => {
  class TourStepTemplateComponent extends TourHotkeyListenerComponent {
    constructor() {
      super(...arguments);
      this.step = {};
      this.tourService = inject(NgxmTourService);
      this.tourStepTemplateService = inject(TourStepTemplateService);
    }
    ngAfterViewInit() {
      this.tourStepTemplateService.templateComponent = this;
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTourStepTemplateComponent_BaseFactory;
        return function TourStepTemplateComponent_Factory(__ngFactoryType__) {
          return (ɵTourStepTemplateComponent_BaseFactory || (ɵTourStepTemplateComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TourStepTemplateComponent)))(__ngFactoryType__ || TourStepTemplateComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourStepTemplateComponent,
        selectors: [["tour-step-template"]],
        contentQueries: function TourStepTemplateComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.stepTemplateContent = _t.first);
          }
        },
        viewQuery: function TourStepTemplateComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(MatMenu, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.tourStep = _t.first);
          }
        },
        inputs: {
          stepTemplate: "stepTemplate"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 4,
        vars: 5,
        consts: [["defaultTemplate", ""], [3, "overlapTrigger"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "step"]],
        template: function TourStepTemplateComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "mat-menu", 1);
            i0.ɵɵtemplate(1, TourStepTemplateComponent_ng_container_1_Template, 1, 0, "ng-container", 2);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(2, TourStepTemplateComponent_ng_template_2_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const defaultTemplate_r2 = i0.ɵɵreference(3);
            i0.ɵɵproperty("overlapTrigger", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngTemplateOutlet", ctx.stepTemplate || ctx.stepTemplateContent || defaultTemplate_r2)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c0, ctx.step));
          }
        },
        dependencies: [MatMenu, NgTemplateOutlet, TourDefaultStepTemplateComponent],
        styles: [".tour-step .mat-mdc-menu-content{padding:0!important}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step{min-width:unset;max-width:unset;overflow:unset;box-shadow:none;filter:drop-shadow(0px 5px 5px rgba(0,0,0,.2)) drop-shadow(0px 8px 10px rgba(0,0,0,.14))}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow{position:relative}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow:after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow:before{bottom:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow:after{border-color:#fff0;border-width:8px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow:before{border-color:#e3e4e600;border-width:9px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before:not(.horizontal):after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before:not(.horizontal):before{right:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before:not(.horizontal):after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before:not(.horizontal):before{right:20px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before:not(.horizontal):before{margin-right:-1px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after:not(.horizontal):after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after:not(.horizontal):before{left:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after:not(.horizontal):after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after:not(.horizontal):before{left:20px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after:not(.horizontal):after{margin-left:1px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below:not(.horizontal){margin-top:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below:not(.horizontal):after{border-top-color:transparent;border-bottom-color:#fff}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below:not(.horizontal):before{border-top-color:transparent;border-bottom-color:#e3e4e6}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above:not(.horizontal){margin-bottom:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above:not(.horizontal):after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above:not(.horizontal):before{top:100%}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above:not(.horizontal):after{border-top-color:#fff;border-bottom-color:transparent}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above:not(.horizontal):before{border-top-color:#e3e4e6;border-bottom-color:transparent}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before.horizontal{margin-right:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before.horizontal:after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before.horizontal:before{left:100%}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before.horizontal:after{border-left-color:#fff;border-right-color:transparent}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-before.horizontal:before{border-left-color:#e3e4e6;border-right-color:transparent}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after.horizontal{margin-left:10px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after.horizontal:after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after.horizontal:before{right:100%}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after.horizontal:after{border-left-color:transparent;border-right-color:#fff}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-after.horizontal:before{border-left-color:transparent;border-right-color:#e3e4e6}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below.horizontal:after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below.horizontal:before{top:16px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-below.horizontal:after{margin-top:1px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above.horizontal:after,   .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above.horizontal:before{bottom:16px}  .mat-mdc-menu-panel.mat-mdc-menu-panel.tour-step.arrow.mat-menu-above.horizontal:after{margin-bottom:1px}"],
        changeDetection: 0
      });
    }
  }
  return TourStepTemplateComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TourProxyAnchorComponent = /*#__PURE__*/(() => {
  class TourProxyAnchorComponent extends BaseTourProxyAnchor {
    constructor() {
      super(...arguments);
      // noinspection JSUnusedGlobalSymbols
      this.anchorDirective = inject(TourAnchorMatMenuDirective, {
        host: true
      });
    }
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵTourProxyAnchorComponent_BaseFactory;
        return function TourProxyAnchorComponent_Factory(__ngFactoryType__) {
          return (ɵTourProxyAnchorComponent_BaseFactory || (ɵTourProxyAnchorComponent_BaseFactory = i0.ɵɵgetInheritedFactory(TourProxyAnchorComponent)))(__ngFactoryType__ || TourProxyAnchorComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TourProxyAnchorComponent,
        selectors: [["tour-proxy-anchor"]],
        inputs: {
          anchorEl: "anchorEl"
        },
        features: [i0.ɵɵHostDirectivesFeature([{
          directive: TourAnchorMatMenuDirective,
          inputs: ["tourAnchor", "anchorId"]
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 0,
        vars: 0,
        template: function TourProxyAnchorComponent_Template(rf, ctx) {},
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return TourProxyAnchorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const COMPONENTS = [TourAnchorMatMenuDirective, TourStepTemplateComponent, TourProxyAnchorComponent];
let TourMatMenuModule = /*#__PURE__*/(() => {
  class TourMatMenuModule {
    static {
      this.ɵfac = function TourMatMenuModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TourMatMenuModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TourMatMenuModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [TourStepTemplateComponent]
      });
    }
  }
  return TourMatMenuModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TourAnchorMatMenuDirective, TourMatMenuModule, TourProxyAnchorComponent, NgxmTourService as TourService, TourStepTemplateComponent };
